import { FormTabs } from "@wac-ui-dashboard/wac_component_library";
import Buy from "./Buy";
import Sell from "./Sell";
import Remittance from "./Remittance";

import useCurrencyRateForm from "./useCurrencyRateForm";
import style from "./currencyRateForm.module.scss";

const CurrencyRateForm = ({ refetch, closeModal }) => {
  const { tabs, activeTab, handleTabClick } = useCurrencyRateForm();
  return (
    <div className={`${style.profile_create} pro-mb-6`}>
      <FormTabs
        tabs={tabs}
        active={activeTab}
        handleClick={handleTabClick}
        propStyle={{ root: style.formTab_root }}
      />
      {activeTab && activeTab === "Buy" ? (
        <Buy refetch={refetch} closeModal={closeModal} />
      ) : activeTab === "Sell" ? (
        <Sell refetch={refetch} closeModal={closeModal} />
      ) : activeTab === "Remittance" ? (
        <Remittance refetch={refetch} closeModal={closeModal} />
      ) : (
        <></>
      )}
    </div>
  );
};

export default CurrencyRateForm;
